import Bowser from "bowser";

export const clientEnvAgentInfo = () => Bowser.getParser(window.navigator.userAgent).getResult();
